import { emptyError } from "../../../Types/ServicesType/servicesType";
import api from "@services/apiList";
import instance from "@services/services";
const {reportsApi}=api
export const paymentTypeWiseReportSearchService = async (data:any): Promise<any> => {
    try {
        const result=await instance.post(reportsApi.paymentTypeWiseReport,data)
        return result.data
    } catch (error) {
        return emptyError
    }
}
export const paymentTypeWiseReportSearchpdfService= async (data:any): Promise<any> => {
    try {
        const result=await instance.post(reportsApi.paymentTypewiseReportPdf,data)
        return result.data
    } catch (error) {
        return emptyError
    }
}
export const paymentTypeWiseReportSearchExcelService= async (data:any): Promise<any> => {
    try {
        const result=await instance.post(reportsApi.paymentTypewiseReportExcel,data)
        return result.data
    } catch (error) {
        return emptyError
    }
}